import React, { useEffect } from 'react'

import EResidencyContent from '../components/EResidency/EResidencyContent';
import NavbarTop from '../components/global/NavbarTop';

const EResidency = () => {
    // const {t} = useTranslation()

    // const language = useSelector(selectLanguage)

    useEffect(() => {
    document.title = "E-Residency | GoPaperless"
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <>
            <NavbarTop />
            <EResidencyContent />
            
        </>
    )
}

export default EResidency